import { nonUndefined } from "Utility";
import { mapTimeAttackRoundWeightings } from "./FsTimeAttackRoundWeighting";
import { TimeAttackScoringAverage } from "model/Match/Set/TimeAttack/Track/Scoring/TimeAttackScoringAverage";
import { TimeAttackScoringBase } from "model/Match/Set/TimeAttack/Track/Scoring/TimeAttackScoring";
import { FsTimeAttackScoringAverage } from "db/model/match/Set/TimeAttack/Scoring/FsTimeAttackScoringAverage";

export const mapTimeAttackScoringAverage = (
  base: TimeAttackScoringBase,
  fsModel: FsTimeAttackScoringAverage
): TimeAttackScoringAverage | undefined => {
  if (!fsModel.roundWeighting) {
    return undefined;
  }

  return {
    ...base,
    type: "Average",
    asPercentage: fsModel.asPercentage ?? false,
    roundWeightings: mapTimeAttackRoundWeightings(
      nonUndefined(fsModel.roundWeighting)
    ),
  };
};
